/**
 * Версия используемого API.
 */
export const API_VERSION = '1.0.0';
